import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-blush/30 px-3 py-4 sm:px-6" data-id="element-70" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-2xl items-start gap-2.5 rounded-md border-2 border-dashed border-magenta bg-white px-3 py-2.5" data-id="element-71" data-mp="1o3do2fp4sjsq">
        <ShieldCheckIcon className="mt-0.5 h-8 w-8 shrink-0 text-magenta" strokeWidth={1.6} aria-hidden="true" data-id="element-72" data-mp="1x4l9vyagns5x" />
        <div data-id="element-73" data-mp="19dzbkyq9dm94">
          <h2 className="text-base font-extrabold uppercase leading-tight text-navy sm:text-xl" data-id="element-74" data-mp="19fsjehclycip">
            Your purchase is 100% protected
          </h2>
          <p className="mt-0.5 text-sm leading-snug sm:text-base" data-id="element-75" data-mp="1j4k5w9ywg4m8">
            Explore HISTOLOGY &amp; PATHOLOGY VISUAL ATLAS™ for 7 days. Access
            the complete 6-module visual study system and all 5 strategic
            bonuses. If it isn't right for you, contact us within 7 days for a
            full refund according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}